import { useMapStore } from '@/stores/useMapStore'

export function useHighlightNodes() {
  const highlights: { setMap: (val: unknown) => void }[] = []

  function highlightNode(map, google, center) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
    svg.setAttribute('width', '80')
    svg.setAttribute('height', '80')
    svg.setAttribute('viewBox', '-40 -40 80 80')

    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
    circle.setAttribute('cx', '0')
    circle.setAttribute('cy', '40')
    circle.setAttribute('r', '20')
    circle.setAttribute('stroke', 'DarkGrey')
    circle.setAttribute('stroke-width', '3')
    circle.setAttribute('fill-opacity', '0')
    circle.setAttribute('stroke-opacity', '0.5')
    svg.appendChild(circle)

    const marker = new google.maps.marker.AdvancedMarkerElement({
      position: center,
      map: map,
      content: svg,
    })

    marker.circleElement = circle

    highlights.push(marker)

    // Pan to highlight
    map.panTo(center)

    animateHighlight(0, marker)
  }

  function animateHighlight(timestamp, marker) {
    const modulo = 2500
    const count = timestamp % modulo

    const opacity = Math.sin((count / modulo) * Math.PI)
    const scale = (count / modulo) * 0.375 + 0.25 // from 0.25 to 0.625

    marker.circleElement.setAttribute('stroke-opacity', opacity.toString())
    marker.circleElement.setAttribute('r', (scale * 40).toString())

    window.requestAnimationFrame((timestamp) =>
      animateHighlight(timestamp, marker)
    )
  }

  function highlightNodes(map, google, highlightedNodes) {
    // Remove existing highlights
    for (const item of highlights) {
      item.setMap(null)
    }

    const mapStore = useMapStore()
    for (let connection of highlightedNodes) {
      const producer = mapStore.getCubeByName(connection, 'tour')
      if (producer) {
        highlightNode(
          map,
          google,
          new google.maps.LatLng(
            producer.params.latitude,
            producer.params.longitude
          )
        )
      }
    }
  }

  return { highlightNodes }
}
